<div class="search-bar">
  <input matInput
         type="text"
         placeholder="{{placeholder}}"
         [(ngModel)]="searchText"
         (input)="onTextChange(searchText)"
         (focusin)="onInputHandleFocus($event)"
         (focusout)="onInputLeaveFocus($event)">
</div>
